module.exports = __webpack_public_path__ + "img/jtz-2.87685b9a.png";